import { useTranslation } from 'react-i18next';
import { useScrollReveal } from '@/hooks/useScrollReveal';

export default function CTAFinal() {
  const { t } = useTranslation('refection');
  const { ref, isVisible } = useScrollReveal<HTMLElement>(0.1);

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section ref={ref} id="cta-final" className="bg-copper py-16 md:py-24">
      <div className="max-w-4xl mx-auto px-4 md:px-6 lg:px-10 text-center">
        <div
          className={`transition-all duration-1000 ${
            isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
          }`}
        >
          <h2 className="font-manrope font-bold text-white text-2xl md:text-3xl lg:text-4xl mb-3 md:mb-4">
            {t('cta_h2')}
          </h2>
          <p className="text-white/80 text-base md:text-lg mb-8 md:mb-10 max-w-2xl mx-auto">
            {t('cta_subtitle')}
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <button
              onClick={() => scrollToSection('quote-form')}
              className="inline-flex items-center gap-2 bg-white hover:bg-soft-gray text-slate-primary font-semibold px-6 py-3.5 rounded-md transition-all duration-300 text-base whitespace-nowrap"
            >
              {t('cta_button')}
              <i className="ri-arrow-right-line" />
            </button>
            <a
              href="tel:+14184769950"
              aria-label="Appeler Couvreur-Lévis.com au 418-476-9950"
              title="Cliquez pour appeler"
              className="inline-flex items-center gap-2 border-2 border-white/40 hover:border-white text-white font-semibold px-6 py-3.5 rounded-md transition-all duration-300 text-base whitespace-nowrap"
            >
              <i className="ri-phone-line" />
              {t('cta_phone')}
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}